import Hashids from 'hashids';

export default class HashIdUtil {
  private constructor() {}

  public static decord(value: string): number {
    return new Hashids('TIMEDESIGNER', 8).decode(value)[0] as number;
  }
}
